export function useCreateQueryParams(filters) {
    const formatted = ref([]);
    const formattedString = ref('');

    function execute() {
        let filter = unref(filters);
        formatted.value = [];
        formattedString.value = '';
        for (const [key, value] of Object.entries(filter)) {
            if (value) {
                formatted.value.push(`${key}=${value}`);
            }
        }
        if (formatted.value.length) {
            formattedString.value = `?${formatted.value.join('&')}`;
        }
    }

    watch(filters, execute, {
        deep: true,
        immediate: true,
    });

    return formattedString;
}
